export const environment = {
    production: true,
    api_url: 'https://api-dev.juyo-intra.com',
    embed_url: 'https://embed-dev.juyo-intra.com',
};
